var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ServiceLayout',{attrs:{"icon":"notext-startrip.png","title":"StarTrip","description":"Cocok untuk anda yang ingin berpergian bebas antar kota atau negara tanpa keterikatan oleh batas waktu.","extra_hour":2,"tariffs":_vm.startrip_tariffs,"lists":_vm.startrip_list}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2afa3998","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Service/StarTrip.vue
// module id = null
// module chunks = 